import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, Sparkles, ArrowRight, Wand2 } from "lucide-react";
import Navbar from "../components/Navbar";
import { api, fileUrl } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function MyDesigns() {
  const { user, loading: authLoading } = useAuth();
  const [designs, setDesigns] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      setDesigns([]);
      return;
    }
    api.get("/stickers/mine").then(({ data }) => setDesigns(data)).catch(() => setDesigns([]));
  }, [user, authLoading]);

  if (authLoading || designs === null) {
    return (
      <div className="App">
        <Navbar />
        <div className="flex justify-center py-32"><Loader2 className="animate-spin" size={40} /></div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="App">
        <Navbar />
        <div className="max-w-lg mx-auto px-5 py-20 text-center">
          <p className="font-head font-bold text-xl mb-6">Please sign in to see your saved designs.</p>
          <Link to="/auth" className="inline-flex items-center gap-2 bg-nbpink text-white font-head font-bold px-6 py-3 rounded-full nb-border nb-shadow nb-press">
            Sign in <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Navbar />
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-10">
        <div className="flex items-center justify-between flex-wrap gap-3 mb-8">
          <h1 className="font-head font-extrabold text-4xl sm:text-5xl">My designs</h1>
          <Link to="/design" className="inline-flex items-center gap-2 bg-nbpink text-white font-head font-bold px-6 py-3 rounded-full nb-border nb-shadow nb-press">
            <Sparkles size={18} /> New design
          </Link>
        </div>

        {designs.length === 0 ? (
          <div className="bg-white nb-border nb-shadow rounded-3xl p-14 text-center">
            <Sparkles size={56} className="mx-auto mb-4 text-nbblack/30" />
            <p className="font-head font-bold text-xl mb-6">No saved designs yet — every sticker you upload lands here.</p>
            <Link to="/design" className="inline-flex items-center gap-2 bg-nbpink text-white font-head font-bold px-6 py-3 rounded-full nb-border nb-shadow nb-press">
              Create your first sticker <ArrowRight size={18} />
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
            {designs.map((d) => (
              <div key={d.id} data-testid="design-card" className="bg-white nb-border nb-shadow rounded-2xl p-3 flex flex-col">
                <div className="aspect-square rounded-xl bg-[#FFF9F0] nb-border overflow-hidden flex items-center justify-center mb-3">
                  {d.preview_path && <img src={fileUrl(d.preview_path)} alt="" className="w-full h-full object-contain p-2" />}
                </div>
                <p className="text-sm font-semibold text-nbblack/60 truncate mb-3">{d.original_filename || "Custom design"}</p>
                <button
                  onClick={() => navigate(`/design?design=${d.id}`)}
                  data-testid={`use-design-${d.id}`}
                  className="mt-auto inline-flex items-center justify-center gap-2 bg-nbyellow font-head font-bold px-4 py-2.5 rounded-full nb-border nb-press"
                >
                  <Wand2 size={16} /> Customize & order
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
